import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const ChevronRightNew16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M6.51667 3.2539L6.51772 3.25493L10.7296 7.42932C10.9189 7.58853 11 7.79721 11 7.99964C11 8.20217 10.9195 8.40714 10.7591 8.56526L6.51737 12.7447C6.18233 13.0719 5.6286 13.0867 5.27771 12.7769C4.92147 12.4638 4.91084 11.9406 5.24452 11.6133L8.91161 7.99969L5.2417 4.38611C4.90758 4.05813 4.9208 3.5367 5.27556 3.22269C5.62789 2.91444 6.18139 2.92746 6.51667 3.2539Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
